import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ContractsAPI } from "../../api/contracts";

export default function ContractForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [form, setForm] = useState({
    supplier_name: "",
    service_description: "",
    start_date: "",
    end_date: "",
    annual_cost: "",
    total_cost: "",
    renewal_notice_period: "",
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isEdit) {
      ContractsAPI.get(id)
        .then(setForm)
        .catch((err) => setError(err.message));
    }
  }, [id, isEdit]);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      if (isEdit) {
        await ContractsAPI.update(id, form);
      } else {
        await ContractsAPI.create(form);
      }
      navigate("/contracts");
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">
        {isEdit ? "Edit Contract" : "New Contract"}
      </h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="grid gap-3 max-w-xl">
        <input
          name="supplier_name"
          value={form.supplier_name}
          onChange={handleChange}
          placeholder="Supplier"
          className="border rounded p-2"
        />
        <input
          name="service_description"
          value={form.service_description}
          onChange={handleChange}
          placeholder="Service"
          className="border rounded p-2"
        />
        <input
          type="date"
          name="start_date"
          value={form.start_date?.slice(0, 10)}
          onChange={handleChange}
          className="border rounded p-2"
        />
        <input
          type="date"
          name="end_date"
          value={form.end_date?.slice(0, 10)}
          onChange={handleChange}
          className="border rounded p-2"
        />
        <input
          type="number"
          name="annual_cost"
          value={form.annual_cost}
          onChange={handleChange}
          placeholder="Annual Cost"
          className="border rounded p-2"
        />
        <input
          type="number"
          name="total_cost"
          value={form.total_cost}
          onChange={handleChange}
          placeholder="Total Cost"
          className="border rounded p-2"
        />
        <input
          type="text"
          name="renewal_notice_period"
          value={form.renewal_notice_period}
          onChange={handleChange}
          placeholder="Renewal Notice Period"
          className="border rounded p-2"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Save
        </button>
      </form>
    </div>
  );
}